export default [
    {
        // [0]
        key: "name",
        label: app.$i18n.t("Name"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "bank",
        label: app.$i18n.t("Bank"),
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "bank_account_type",
        label: app.$i18n.t("Type"),
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "account_number",
        label: app.$i18n.t("Account number"),
        tdClass: "text-center",
        thClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "balance",
        label: app.$i18n.t("Balance"),
        tdClass: "text-center",
        thClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "status",
        label: app.$i18n.t("Status"),
        tdClass: "text-center",
        thClass: "text-center",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "created_at",
        label: app.$i18n.t("Created at"),
        sortable: true,
        visible: true,
    },
    {
        // [13]
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]